import { useEffect, useState } from 'react';
import { getMcpServers } from '../services/McpTesterService';

/**
 * How many MCP servers the project's services expose (vfs-service GET /mcp/servers: found in their code or declared in
 * `.flow/service.json` "mcp"; stdio-only ones not counted): the MCP tab's Auto reason (utils/projectTabsModel.js
 * `mcpServers`). Read once per project and again when `refreshKey` changes (the service list); any failure (an older
 * or sleeping sandbox) is 0.
 */
export default function useMcpServersSignal(projectId, refreshKey = '') {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!projectId) { setCount(0); return undefined; }
    let live = true;
    Promise.resolve().then(() => getMcpServers(projectId))
      .then((answer) => { if (live) { setCount(Number(answer?.count) || 0); } })
      .catch(() => { if (live) { setCount(0); } });
    return () => { live = false; };
  }, [projectId, refreshKey]);
  return count;
}
